import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface PageTitleProps {
	name: string;
}

const PageTitle: FunctionComponent<PageTitleProps> = ({ name }) => {
	const { t } = useTranslation();

	return <title>{`${t('TITLE.HP')} - ${name}`}</title>;
};

export default PageTitle;
